import { createContext } from 'react';

export const FeedContext = createContext({});
